<div style="padding: 0; position: relative">
  <div style="padding: 20px; -webkit-box-shadow: 0px 2px 1px 0px rgba(240,240,240,1);
       -moz-box-shadow: 0px 2px 1px 0px rgba(240,240,240,1);
       box-shadow: 0px 2px 1px 0px rgba(240,240,240,1)">
    <div style=" margin-bottom: 0; margin-top: 0; display: flex">
      Edit buyer
      <span *ngIf="noPropertySelected" style="margin-left: 10px; color: #b40000">Please select a property</span>
    </div>
  </div>
  <div style="padding: 20px; height: 500px; overflow: scroll">
    <form [formGroup]="buyerInfoForm">
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>Title</mat-label>
        <mat-select formControlName="title">
          <mat-option [value]=1>Mr.</mat-option>
          <mat-option [value]=2>Miss</mat-option>
          <mat-option [value]=3>Mrs.</mat-option>
          <mat-option [value]=4>Dr.</mat-option>
        </mat-select>
        <mat-error *ngIf="f.title.errors && f.title.errors.required">
          Title is required
        </mat-error>
      </mat-form-field>
      <div style="display: flex; justify-content: space-between">
        <mat-form-field appearance="outline" style="width: 45%">
          <mat-label>First name</mat-label>
          <input matInput formControlName="firstName">
          <mat-error *ngIf="f.firstName.errors && f.firstName.errors.required">
            First name is required
          </mat-error>
          <mat-error
            *ngIf="!buyerInfoForm.hasError('minLength', 'firstName') &&  !buyerInfoForm.hasError('maxLength', 'firstName') && f.firstName.errors && !f.firstName.errors.required">
            First name should be {{constants.MIN_FIRSTNAME_LENGTH}} - {{constants.MAX_FIRSTNAME_LENGTH}}
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" style="width: 45%">
          <mat-label>Last name</mat-label>
          <input matInput formControlName="lastName">
          <mat-error *ngIf="f.lastName.errors && f.lastName.errors.required">
            Last name is required
          </mat-error>
          <mat-error
            *ngIf="!buyerInfoForm.hasError('minLength', 'lastName') &&  !buyerInfoForm.hasError('maxLength', 'lastName') && f.lastName.errors && !f.lastName.errors.required">
            Last name should be {{constants.MIN_LASTNAME_LENGTH}} - {{constants.MAX_LASTNAME_LENGTH}}
          </mat-error>
        </mat-form-field>
      </div>
      <div style="display: flex; justify-content: space-between">
        <mat-form-field appearance="outline" style="width: 45%">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email">
          <mat-error *ngIf="f.email.errors && f.email.errors.required">
            Email is required
          </mat-error>
          <mat-error
            *ngIf="!buyerInfoForm.hasError('maxLength', 'email') && !buyerInfoForm.get('email').hasError('pattern') && f.email.errors && !f.email.errors.required">
            Email maximum length is {{constants.MAX_EMAIL_LENGTH}}
          </mat-error>
          <mat-error
            *ngIf="buyerInfoForm.get('email').hasError('pattern') && f.email.errors && !f.email.errors.required">
            Please enter a valid email
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" style="width: 45%">
          <mat-label>Phone</mat-label>
          <input matInput formControlName="phoneNumber">
          <mat-error *ngIf="f.phoneNumber.errors && f.phoneNumber.errors.required">
            Phone is required
          </mat-error>
          <mat-error
            *ngIf="!buyerInfoForm.hasError('maxLength', 'phoneNumber') && !buyerInfoForm.get('phoneNumber').hasError('pattern') && f.phoneNumber.errors && !f.phoneNumber.errors.required">
            Phone length should be {{constants.MIN_PHONE_NUMBER_LENGTH}} - {{constants.MAX_PHONE_NUMBER_LENGTH}}
          </mat-error>
          <mat-error
            *ngIf="buyerInfoForm.get('phoneNumber').hasError('pattern') && f.phoneNumber.errors && !f.phoneNumber.errors.required">
            Please enter a valid phone
          </mat-error>
        </mat-form-field>
      </div>
      <div>
        <h4>Buyer address</h4>
        <app-auto-complete (setAddress)="getAddress($event)" addressType="geocode" [style]="style"></app-auto-complete>
        <div style="display: flex; justify-content: space-between">
          <mat-form-field appearance="outline" style="width: 45%">
            <mat-label>Street</mat-label>
            <input matInput formControlName="street">
            <mat-error *ngIf="!buyerInfoForm.hasError('maxLength', 'street')">
              Street maximum length is {{constants.MAX_ADDRESS_LINE2_LENGTH}}
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 45%">
            <mat-label>Suburb</mat-label>
            <input matInput formControlName="suburb">
            <mat-error *ngIf="!buyerInfoForm.hasError('maxLength', 'suburb')">
              Suburb maximum length is {{constants.MAX_AREA_LENGTH}}
            </mat-error>
          </mat-form-field>
        </div>
        <div style="display: flex; justify-content: space-between">
          <mat-form-field appearance="outline" style="width: 45%">
            <mat-label>State</mat-label>
            <input matInput formControlName="state">
            <mat-error *ngIf="!buyerInfoForm.hasError('maxLength', 'state')">
              State maximum length is {{constants.MAX_STATE_LENGTH}}
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 45%">
            <mat-label>Postcode</mat-label>
            <input matInput formControlName="postCode">
            <mat-error *ngIf="!buyerInfoForm.hasError('maxLength', 'postCode')">
              Postcode maximum length is {{constants.MAX_POSTCODE_LENGTH}}
            </mat-error>
          </mat-form-field>
        </div>
        <mat-form-field appearance="outline" style="width: 45%">
          <mat-label>Country</mat-label>
          <input matInput formControlName="country">
          <mat-error *ngIf="!buyerInfoForm.hasError('maxLength', 'country')">
            Country maximum length is {{constants.MAX_COUNTRY_LENGTH}}
          </mat-error>
        </mat-form-field>
      </div>
      <div>
        <h4 class="fc_DEDEDE">Buyer type</h4>
        <h4
          [ngStyle]="{color: submitted && f.firb.errors ? '#f44336' : '#000', marginTop: '0', marginBottom: '10px', fontFamily: 'Poppins Regular'}">
          FIRB *</h4>
        <mat-radio-group formControlName="firb" (change)="firbChanged($event)">
          <mat-radio-button [value]=1 style="margin-right: 40px">Yes</mat-radio-button>
          <mat-radio-button [value]=0>No</mat-radio-button>
        </mat-radio-group>
        <div *ngIf="f.firb.value === 0">
          <mat-radio-group formControlName="isLocalInvestor" style="margin-bottom: 20px">
            <h4
              [ngStyle]="{color: submitted && f.isLocalInvestor.errors ? '#f44336' : '#000', fontFamily: 'Poppins Regular', marginBottom: '10px'}">
              Is buyer a local investor? *</h4>
            <mat-radio-button [value]=1 style="margin-right: 40px">
              Yes
            </mat-radio-button>
            <mat-radio-button [value]=0>
              No
            </mat-radio-button>
          </mat-radio-group>
          <mat-radio-group formControlName="isLocalFirstHomeBuyer" style="margin-bottom: 20px">
            <h4
              [ngStyle]="{color: submitted && f.isLocalFirstHomeBuyer.errors ? '#f44336' : '#000', fontFamily: 'Poppins Regular', marginTop: '20px', marginBottom: '10px'}">
              Is buyer a local first home buyer? *</h4>
            <mat-radio-button [value]=1 style="margin-right: 40px">
              Yes
            </mat-radio-button>
            <mat-radio-button [value]=0>
              No
            </mat-radio-button>
          </mat-radio-group>
          <mat-radio-group formControlName="isLocalDownsize" style="margin-bottom: 20px">
            <h4
              [ngStyle]="{color: submitted && f.isLocalDownsize.errors ? '#f44336' : '#000', fontFamily: 'Poppins Regular', marginTop: '20px', marginBottom: '10px'}">
              Is buyer a local downsize buyer? *</h4>
            <mat-radio-button [value]=1 style="margin-right: 40px">
              Yes
            </mat-radio-button>
            <mat-radio-button [value]=0>
              No
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div>
        <h4>Select a property</h4>
        <app-property-selection [properties]="this.data.project.properties" [currentProperty]="this.data.property"
          (changeNewPropertyId)="getNewPropertyId($event)">
        </app-property-selection>
      </div>
      <button mat-button (click)="submit()"
        style="background: #3C50E0; color: #fff;  margin-top: 20px; margin-bottom: 0; position: absolute; top: -5px; right: 20px">
        Submit
      </button>
    </form>
  </div>
</div>